module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "default-panel default-bg orderDetails-sec"
  }, [_c('normalBar', {
    attrs: {
      "title": "订单详情",
      "path": _vm.path
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grey-bg-sec pd40"
  }, [_c('div', {
    staticClass: "order-header-sec"
  }, [_c('div', {
    staticClass: "timer-sec"
  }, [_c('ul', {
    staticClass: "order-timer-list"
  }, [_c('li', [_c('span', {
    staticClass: "text-grey"
  }, [_vm._v("下单时间")]), _c('span', [_vm._v(_vm._s(_vm.createdTime))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text-grey"
  }, [_vm._v("订单号")]), _c('span', [_vm._v(_vm._s(_vm.merchantId))])]), _vm._v(" "), (_vm.payModesDesc) ? _c('li', [_c('span', {
    staticClass: "text-grey"
  }, [_vm._v("付款方式")]), _c('span', [_vm._v(_vm._s(_vm.payModesDesc))])]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text-grey"
  }, [_vm._v("商品总计")]), _c('span', [_vm._v("¥" + _vm._s(_vm._f("filterPrice")(_vm.totalGoodsAmount)))])]), _vm._v(" "), (_vm.freightAmount) ? _c('li', [_c('span', {
    staticClass: "text-grey"
  }, [_vm._v("发票运费")]), _c('span', [_vm._v("¥" + _vm._s(_vm._f("filterPrice")(_vm.freightAmount)))])]) : _vm._e(), _vm._v(" "), (_vm.couponAmount) ? _c('li', [_c('span', {
    staticClass: "text-grey"
  }, [_vm._v("优惠券")]), _c('span', [_vm._v("¥" + _vm._s(_vm._f("filterPrice")(_vm.couponAmount)))])]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text-grey"
  }, [_vm._v("订单总计")]), _c('span', [_vm._v("¥" + _vm._s(_vm._f("filterPrice")(_vm.totalOrderAmount)))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text-grey"
  }, [_vm._v("订单备注")]), _c('span', [_vm._v(_vm._s(_vm.remarks || '无'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "price-sec"
  }, [_c('div', [_c('span', {
    staticClass: "text-red"
  }, [_c('p', [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.status == 1 ? '需付款' : '实付款'))]), _vm._v(" ¥" + _vm._s(_vm._f("filterPrice")(_vm.status == 1 ? _vm.receiveTotalAmount : _vm.payTotalAmount)))])])]), _vm._v(" "), (_vm.status == 1) ? _c('span', [_c('countDown', {
    attrs: {
      "timer": _vm.payTime,
      "payNo": _vm.payNo
    },
    on: {
      "timerOut": _vm.timerOuts
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _vm._l((_vm.giftBoxVoList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "grey-bg-sec"
    }, [_c('div', {
      staticClass: "pro-sec"
    }, [_c('div', {
      staticClass: "gift-header"
    }, [_vm._v("礼盒" + _vm._s(index + 1) + " "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(item.userOrderStatusDesc))])]), _vm._v(" "), _c('div', {
      staticClass: "gift-sec"
    }, [_c('div', {
      staticClass: "address-sec"
    }, [_c('div', {
      staticClass: "address-content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("收货地址")]), _vm._v(" "), _c('p', {
      staticClass: "big-size"
    }, [_vm._v(_vm._s(item.recipientVo.name)), _c('span', {
      staticClass: "last"
    }, [_vm._v("收")]), _vm._v(_vm._s(_vm._f("filterPhone")(item.recipientVo.mobile)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.recipientVo.provinceName) + " " + _vm._s(item.recipientVo.cityName) + "  " + _vm._s(item.recipientVo.regionName) + " " + _vm._s(item.recipientVo.address))])]), _vm._v(" "), (item.userOrderStatus !== 1) ? _c('button', {
      staticClass: "default-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.checkExpressInfo(item.orderCode)
        }
      }
    }, [_vm._v("物流详情")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "gift-body"
    }, _vm._l((item.merchantOrderDetailGoodsVos), function(order) {
      return _c('router-link', {
        key: index,
        attrs: {
          "to": {
            path: '/productdetail/' + order.goodsChannelId,
            query: {
              url: _vm.router
            }
          }
        }
      }, [_c('div', {
        staticClass: "media"
      }, [_c('div', {
        staticClass: "media-left"
      }, [(!!order.imgUrl) ? _c('img', {
        attrs: {
          "src": order.imgUrl,
          "alt": ""
        }
      }) : _c('img', {
        attrs: {
          "src": require("../../assets/images/default-pro-small.png"),
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "media-content"
      }, [_c('p', {
        staticClass: "m-title"
      }, [_c('span', [_vm._v(_vm._s(order.showGoodsName))]), _vm._v(" "), _c('span', {
        staticClass: "m-small"
      }, [_vm._v("X" + _vm._s(order.orderGoodsNum))])]), _vm._v(" "), _c('span', {
        staticClass: "m-subTitle text-grey"
      }, [_vm._v(_vm._s(order.skuProperty))]), _vm._v(" "), _c('div', {
        staticClass: "m-operate"
      }, [_c('div', {
        staticClass: "m-operate-cont"
      }, [_c('span', {
        staticClass: "price text-red"
      }, [_vm._v("¥" + _vm._s(_vm._f("filterPrice")(order.salePrice)))]), _vm._v(" "), (order.chocoBoard) ? _c('span', {
        staticClass: "chocoBoard text-grey"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t生日牌：" + _vm._s(order.chocoBoard ? order.chocoBoard : '无') + "\n\t\t\t\t\t\t\t\t\t")]) : _vm._e()])])])]), _vm._v(" "), (order.greetingCard) ? _c('div', {
        staticClass: "greetingCard text-grey"
      }, [_c('span', {
        staticClass: "first"
      }, [_vm._v("祝福贺卡：")]), _c('span', {
        staticClass: "second"
      }, [_vm._v(_vm._s(order.greetingCard))])]) : _vm._e()])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "order-details-foot"
    }, [(item.deliveryType == 1 || item.deliveryType == 2) ? _c('div', {
      staticClass: "details-info"
    }, [_c('p', [_c('span', {
      staticClass: "text-grey"
    }, [_vm._v(_vm._s(item.deliveryTypeDesc))]), _c('span', [_vm._v(_vm._s(item.deliveryTime))])])]) : _vm._e(), _vm._v(" "), (item.deliveryType == 3) ? _c('div', {
      staticClass: "details-info"
    }, [_vm._m(0, true), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "text-grey"
    }, [_vm._v("物流单号")]), (item.expressVo.expressName) ? _c('span', [_vm._v(_vm._s(item.expressVo.expressName) + " " + _vm._s(item.expressVo.expressNumber))]) : _c('span', [_vm._v("暂无信息")])])]) : _vm._e(), _vm._v(" "), (item.userOrderStatus == 7 || item.userOrderStatus == 8) ? _c('button', {
      staticClass: "default-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.checkReceive(item.orderCode)
        }
      }
    }, [_vm._v("确认收货")]) : _vm._e(), _vm._v(" "), (_vm.giftBoxVoList.length > 1 && item.cancel == 1 && _vm.status != 1) ? _c('button', {
      staticClass: "default-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.orderCancel(item.orderCode)
        }
      }
    }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), (item.userOrderStatus == 15 || item.userOrderStatus == 16) ? _c('button', {
      staticClass: "default-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.checkRefundDetails(item.orderCode)
        }
      }
    }, [_vm._v("退款详情")]) : _vm._e()])])])
  }), _vm._v(" "), (_vm.cancelStatus == 1 && _vm.status == 1) ? _c('div', {
    staticClass: "order-type-foot",
    on: {
      "click": function($event) {
        _vm.orderMchCancel()
      }
    }
  }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), ((_vm.giftBoxVoList.length == 1 && _vm.giftBoxVoList[0].cancel == 1 && _vm.status !== 1)) ? _c('div', {
    staticClass: "order-type-foot",
    on: {
      "click": function($event) {
        _vm.orderCancel(_vm.giftBoxVoList[0].orderCode)
      }
    }
  }, [_vm._v("取消订单")]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "text-grey"
  }, [_vm._v("快递寄送")]), _c('span', [_vm._v("下单后48小时内统一发货")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00e062e9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/orderDetails.vue
// module id = 542
// module chunks = 1